import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const InbodyService = {
  async getDateTimes(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`inbody/datetime`, payload);
  },

  async getFullInBodyData(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`inbody/data`, payload);
  },
};
export default InbodyService;
